import axios from "axios";
import Cookies from "js-cookie";

export const BASE_URL =   process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_SERVER_HOSTNAME ||
  "https://api.drmeditation.net";

const http = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

http.interceptors.request.use((config) => {
  const token = Cookies.get("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default http;
